import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { setPageTitle } from "../utils/pageTitle";
import ScrollToTopButton from "./ScrollToTopButton";
import CookieConsent from "./CookieConsent";
export default function Layout({ children, pageTitle = "Home" }) {
  useEffect(() => {
    setPageTitle(pageTitle);
  }, [pageTitle]);

  // Set document title if pageTitle is provided
  useEffect(() => {
    if (pageTitle) {
      document.title = `${pageTitle} | Pharmacy Wiki`;
    } else {
      document.title = "Pharmacy Wiki";
    }
  }, [pageTitle]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <ScrollToTopButton />
      <Footer className="mt-auto" />
      <CookieConsent />
    </div>
  );
} 